import {Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

const FieldLabel = styled(Typography)(() => ({
  fontSize: 13,
  fontWeight: 'bold',
  marginBottom: 8
}));

export default FieldLabel;
